var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{attrs:{"href":("/sor/info/" + (_vm.props.row.__typename) + "/" + (_vm.props.row.dbId) + "/info"),"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.props.data && _vm.props.data.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }